<template>
    <div style="padding: 0 12px;">
        <swiper style="border-radius: 20px; height: 100%; overflow: hidden; " :options="swiperOption" role="tablist" ref="swiper">
            <swiper-slide v-for="each, i in eventList" :key="i" style="width: 100%; height: 100%; position: relative; border-radius: 12px;" role="tab">
                <div class="img_wrap" style="position: absolute; z-index: 1; height: 100%; width: 100%;">
                    <img style="width: 100%; height: 100%; object-fit: cover;" :src="$resourcePath + each.image_path" alt="">
                    <!-- <img style="width: 100%; height: 100%; object-fit: cover;" :src=" require('@/assets/img/testt.jpg')" alt="" @click="doAction(each)"> -->
                </div>
                <div style="position: relative; z-index: 2;">
                    <div style="display: flex; padding: 0 20px; margin-top: 11px; gap: 6px;">
                        <div style="border-radius: 8px; background-color: #ff0000; color: #fff; font-size: 12px; padding: 4px 11px; font-weight: 700;">D-{{ remainDay(each.end_date) }}</div>
                        <div style="font-size: 12px; border-radius: 20px; border: 1px solid #bbbbbb; background: #0D0D0DC4; color: #fff; padding: 4px 9px;"><span style="margin-right: 4px;">🔥</span> 2,193명 도전중</div>
                    </div>
                    <div style="padding: 0 20px; font-weight: 700; color: #fff;">
                        <div style="font-size: 20px; line-height: 36px; margin-top: 4px;">{{ each.product_name }}</div>
                        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                            <div style="display: flex;align-items: center; gap: 10px;">
                                <div style="">{{ each.discount_price | comma }}원</div>
                                <div style="color: #8a8a8a; font-size: 12px; font-weight: 400; text-decoration: line-through;">{{ each.original_price | comma }}</div>
                            </div>
                            <div  @click="showEventPage(each.idx)" style="width: 73px; height: 30px; line-height: 30px; text-align: center; color: var(--color-main); border-radius: 8px; background-color: #000;">도전하기</div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <div class="swiper-pagination paging_text" slot="pagination" style="font-size:12px; top: 6px; height: 20px; text-align: right; padding-right: 20px; z-index: 10; display:inline-block;"></div>
        </swiper>
    </div>

</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import moment from 'moment'

export default {
    name: "SwipedEventBannerSmall",
    components: { swiper, swiperSlide },
    props: {
        home_banners: {
            type: Array,
            default: () => {}
        }
    },
    data() {
        return {
            swiperOption: {
                // slidesPerView: 'auto',
                spaceBetween: 0, // swiper-slide 사이의 간격 지정
                slidesOffsetBefore: 0, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
                slidesOffsetAfter: 0, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
                freeMode: false, // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
                centerInsufficientSlides: true, // 컨텐츠의 수량에 따라 중앙정렬 여부를 결정함
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },
                autoplay: {
                    delay: 5000
                },
                curIndex: 0,
            },
            eventList: []
        }
    },
    created() {
        this.getEventList()
    },
    methods: {
        remainDay(endDate) {
            const now = moment()
            const target = moment(endDate, 'YYYY-MM-DD').startOf('day')
                
            return Math.floor(
                moment.duration(target.diff(now)).asDays()
            )
        },
        doAction(banner) {
            if (banner.idx === 7) {
                this.$Util.sendEventClick('홈_스포트라이트_배너_상단', true);
            } else if (banner.idx === 6) {
                this.$Util.sendEventClick('홈_축구팀_입단_배너', true)
            }

            console.log();

            window.pushCustomManager.goScreen(null, banner.param1, banner.action, banner.param1);
        },
        showEventPage(idx) {
            this.$GlobalStore.addModal('EventPage', { event_idx: idx })
        },
        async getEventList() {
            const res =  await this.$Axios.get('/api/event/list')
            const eventList = res.data.event_list
            this.eventList = eventList
        }

    }
}
</script>

<style scoped>
.swiper-pagination>>>.swiper-pagination-bullet-active {
    background: #fff
}

.swiper-pagination>>>.swiper-pagination-bullet {
    width: 6px;
    height: 6px;
}

.img_wrap::after {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.6); /* 옅은 검정 */
    pointer-events: none;
}
</style>